import styled from "@emotion/styled";
import {
  Avatar,
  Col,
  Dropdown,
  Menu,
  MenuProps,
  Image,
  Modal,
  Tag,
  Typography,
  message,
} from "antd";
import { FC, useState } from "react";
import { locationIcon } from "assets/icons";
import {
  LoadAgentContactsData,
  deleteAgentImmediatelyInput,
} from "services/interface";
import {
  CrownOutlined,
  ExclamationCircleFilled,
  MoreOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import noImage from "assets/images/no-image.png";
import { formatDateWithTime } from "utils/dateFormat";
import { useDeleteUserImmediately } from "hooks/useFactory";
import { useAppSelector } from "store";
const { confirm } = Modal;

interface RetailDataCardProps {
  data: LoadAgentContactsData;
  //AgentListResponse
  refetch: () => void;
  // refetchTo?: () => void;
  handleAfterDelete: () => void;
}

// const { confirm } = Modal;

const RetailDataCard: FC<RetailDataCardProps> = ({
  data,
  refetch,
  handleAfterDelete,
}) => {
  // data, refetch, refetchTo
  // const { mutate } = useDeleteProduct();
  // const { mutate : updateStatus } = useUpdateStatusProduct();
  const { mutate: deleteUser } = useDeleteUserImmediately();

  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdownVisibleChange = (visible: boolean) => {
    setIsDropdownOpen(visible);
  };

  const updateNavigate = (id: string) => {
    navigate(`/manage-agent/update-retail/${id}`);
  };

  const showDeleteConfirm = (id: string) => {
    if (!id) return;
    const data: deleteAgentImmediatelyInput = {
      ref_id: id,
      ref_type: "retail",
      remark: "ยื่นคำร้องขอลบลูกค้า",
      factory_id: factoryId || "",
    };
    confirm({
      title: "คุณต้องการลบผู้ใช้งานนี้ใช่หรือไม่",
      icon: <ExclamationCircleFilled />,
      content: "ผู้ใช้ลูกค้านี้จะหายไปจากระบบ และ ไม่สามารถกู้คืนได้",
      okText: "ใช่, ต้องการลบ",
      okType: "danger",
      cancelText: "ไม่, ยกเลิกการลบ",
      onOk() {
        deleteUser(data, {
          onSuccess: (data) => {
            if (data.status === "success") {
              message.success("ลบ ลูกค้า สำเร็จ");
              refetch();
              handleAfterDelete();
            } else {
              message.error(`${data.error_message}`);
            }
          },
          onError: () => {
            message.error("ลบ ลูกค้าร็จ");
          },
        });
      },
      onCancel() {
        //console.log("Cancel");
      },
    });
  };

  return (
    <Col sm={24} md={8} xl={8} span={24}>
      {/* onClick={() => setIsDropdownOpen(!isDropdownOpen)} */}
      <CardContainer>
        <ImageWrapper>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Image
              // width={180}
              src={`${data?.image ?? noImage}`}
              style={{ objectFit: "cover" }}
            />
          </div>
          {/* <img
                src={data?.image ?? noImage}
                width={"100%"}
                height={"100%"}
                style={{ objectFit: "cover" }}
              /> */}
        </ImageWrapper>
        <Content
          style={{ cursor: "pointer" }}
          onClick={() => {
            updateNavigate(data.id);
          }}
        >
          <TextWrapper>
            <Typography.Text className="text-order-agent-name-underline">
              {data && data.contact_name && data?.contact_name.length > 50
                ? data?.contact_name.slice(0, 50) + "..."
                : data?.contact_name}
            </Typography.Text>
            <Typography.Text className="text-order-agent-name">
              {" "}
              {data && data.alias ? `(${data.alias})` : ""}
            </Typography.Text>
          </TextWrapper>

          <TextWrapper>
            <Typography.Text className="text-order-product-name">
              {locationIcon}
            </Typography.Text>
            <Typography.Text className="text-order-product-name">
              {data?.location || "-"}
            </Typography.Text>
          </TextWrapper>

          <Typography.Text className="text-order-product-name">
            {[data?.telephone, ...(data?.contact_mobile || [])].join(", ") ||
              "-"}
          </Typography.Text>

          <TextWrapper>
            <Typography.Text className="text-order-product-name">
              วันที่สร้าง:
              {formatDateWithTime(data?.create_date || "")}
            </Typography.Text>
            <Typography.Text className="text-order-product-name"></Typography.Text>
          </TextWrapper>

          <TextWrapper>
            <Typography.Text className="text-order-product-name">
              ผู้สร้าง:
            </Typography.Text>
            <Typography.Text className="text-order-product-name">
              {data?.create_name.trim() || "-"}
            </Typography.Text>
          </TextWrapper>

          <TextWrapper>
            <Typography.Text className="text-order-product-name">
              สถานะข้อมูล:
            </Typography.Text>
            <Typography.Text className="text-order-product-name">
              {data?.is_active ? (
                <Tag color="blue">Active</Tag>
              ) : (
                <Tag color="grey">Inactive</Tag>
              )}
            </Typography.Text>
          </TextWrapper>

          <TextWrapper style={{ marginTop: "5px" }}>
            <Typography.Text className="text-order-product-name">
              {data?.is_vip ? (
                <Tag color="red">
                  <CrownOutlined /> VIP
                </Tag>
              ) : (
                ""
              )}
              {data?.line_id ? (
                <Tag color="green">เชื่อมต่อกับไลน์แล้ว</Tag>
              ) : (
                <Tag>ยังไม่ได้เชื่อมต่อกับไลน์</Tag>
              )}
            </Typography.Text>
          </TextWrapper>
        </Content>
        <MoreOptionsContainer>
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="1"
                  onClick={() => {
                    updateNavigate(data.id);
                  }}
                >
                  จัดการข้อมูล
                </Menu.Item>
                {/* <Menu.Item
                    key="2"
                    onClick={() => {
                      showDeleteConfirm(data.id);
                    }}
                  >
                    ลบผู้ใช้
                  </Menu.Item> */}
              </Menu>
            }
          >
            <MoreOptions>
              <MoreOutlined />
            </MoreOptions>
          </Dropdown>
        </MoreOptionsContainer>
      </CardContainer>
    </Col>
  );
};

export default RetailDataCard;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CardContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 16px;
`;
// box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const MoreOptionsContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
`;

const MoreOptions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e0e0e0;
  }
`;
const ImageWrapper = styled.div`
  width: 60px;
  height: 60px;
  background-color: #efefef;
  margin-right: 10px;
`;
